import { Button, Divider, Input, Select, type SelectProps } from "antd"
import React, { useState } from "react"
import { Plus as PlusIcon } from "react-feather"
import { useTranslation } from "react-i18next"
import { type FormSelectOption } from "~Components/form/form.types"
import { getPopupAnchor } from "~Shared/utils/popup.utils"
import { getUnitOfMeasureOptions, searchByLabelFilterOption } from "../../shared/utils/form.utils"

interface UnitOfMeasureSelectProps extends SelectProps<string, FormSelectOption> {}

export const UnitOfMeasureSelect = ({ value, onChange, placeholder, disabled, className }: UnitOfMeasureSelectProps) => {
    const { t } = useTranslation()

    const [customUnitOfMeasureOptions, setCustomUnitOfMeasureOptions] = useState<Array<FormSelectOption>>(getUnitOfMeasureOptions(t))
    const [customUnitOfMeasure, setCustomUnitOfMeasure] = useState<string>("")

    const renderUnitOfMeasureDropdown = (menu: React.ReactElement<any, string | React.JSXElementConstructor<any>>) => (
        <>
            {menu}
            <Divider className="my-6" />
            <Input.Group className="flex flex-row space-x-4" compact>
                <Input value={customUnitOfMeasure} onChange={(e) => setCustomUnitOfMeasure(e.target.value)} placeholder={t("input:add_custom_unit")} />
                <Button
                    onClick={() => {
                        if (customUnitOfMeasure.trim()) {
                            setCustomUnitOfMeasureOptions((prev) => [...prev, { param: customUnitOfMeasure, value: customUnitOfMeasure }])
                            setCustomUnitOfMeasure("")
                        }
                    }}
                    disabled={!customUnitOfMeasure.trim()}
                >
                    <PlusIcon />
                </Button>
            </Input.Group>
        </>
    )

    return (
        <Select
            value={value}
            onChange={onChange}
            getPopupContainer={getPopupAnchor()}
            dropdownRender={renderUnitOfMeasureDropdown}
            placeholder={placeholder}
            disabled={disabled}
            className={className}
            showSearch
            filterOption={searchByLabelFilterOption}
        >
            {customUnitOfMeasureOptions.map((item) => (
                <Select.Option value={item.value} key={item.value} label={item.param}>
                    {item.param}
                </Select.Option>
            ))}
        </Select>
    )
}
